import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from '../auth/auth.models';

/**
 * Decode JWT token
 */
export function decodeToken<T = JwtPayload>(token: string): T {
  return jwtDecode<T>(token);
}

/**
 * Check if token is valid (not expired)
 */
export function isTokenValid(token: string): boolean {
  try {
    const decoded = decodeToken<JwtPayload>(token);
    return decoded?.exp ? decoded.exp * 1000 > Date.now() : false;
  } catch {
    return false;
  }
}

/**
 * Extract permission bitmask from JWT payload
 * Checks permissionMask first, then falls back to permission
 */
export function extractPermissionMask(payload: JwtPayload): bigint {
  const permissionValue = payload.permissionMask ?? payload.permission;
  
  if (permissionValue === null || permissionValue === undefined) {
    return 0n;
  }
  
  try {
    return BigInt(permissionValue);
  } catch {
    return 0n;
  }
}

